export default {
    ALLERGENS: 'allergens',
    ALLERGENS_ADDITIONAL: 'allergens-additional',
    ALLERGENS_SUITABILITY: 'allergens-suitability',
    COMPANY: 'company',
    COMPANY_ADDRESS: 'company-address',
    COMPANY_ALLOWANCE: 'company-allowance',
    COMPANY_ALLOWANCE_BALANCE_TYPES: 'company-allowance-balance-types',
    COMPANY_ALLOWANCE_TIME_UNITS: 'company-allwoance-time-units',
    COUNTRY: 'country',
    DELIVERY_METHOD: 'delivery-methods',
    DELIVERY_NOTIFICATION_TEMPLATE: 'delivery-notification-template',
    MEAL: 'meals',
    MEAL_CATEGORY: 'meal-category',
    MEAL_OPTION_GROUP: 'meal-option-group',
    ORDERING_SOFTWARE: 'ordering-software',
    ORDER_REFUND_BEHALF: 'order-refund-behalf',
    ORDER_STATUS: 'order-status',
    PAYMENT_METHODS: 'payment-methods',
    PROMOTION_DISCOUNT_TYPES: 'promotion_discount_types',
    PROMOTION_TYPES: 'promotion_types',
    RESTAURANT: 'restaurant',
    RESTAURANT_DELIVERY_AREA_TYPE: 'restaurant_delivery_area_type',
    RESTAURANT_PRICE_CATEGORIES: 'restaurant_price_categories',
    RESTAURANT_TAGS: 'restaurant_tags',
    RESTAURANT_TAG_GROUPS: 'restaurant_tag_groups',
    SUITABLE_FOR_CONSTRAINTS: 'suitable-for-constraints',
    USER: 'user',
    USER_NOTIFICATIONS: 'user-notifications',
    VAT: 'vat',
    VEHICLE_TYPE: 'vehicle-types',
    RESIDENTIAL_CANTEEN_ADDRESS: 'residential-canteen-address',
    RESIDENTIAL_CANTEEN_RESTAURANT: 'residential-canteen-restaurant',
    USER_EXTRA_ROLES: 'user-extra-roles',
}
